/* Editorial video helper. Loaded once from layout.
   Binds each [data-lshk-media] instance. Does not autoplay until
   prefers-reduced-motion has been checked. Section load/unload only. */
(function () {
  var BOUND = 'lshk-media-bound';

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function buttonFor(el) {
    return el.querySelector('[data-lshk-media-toggle]');
  }

  function markPlaying(el, playing) {
    el.setAttribute('data-lshk-playing', playing ? 'true' : 'false');
    var button = buttonFor(el);
    if (button) button.setAttribute('aria-pressed', playing ? 'false' : 'true');
  }

  function invalidatePlay(el) {
    el._lshkPlaySerial = (el._lshkPlaySerial || 0) + 1;
    var playAbort = el._lshkPlayAbort;
    el._lshkPlayAbort = null;
    if (playAbort) {
      try {
        playAbort.abort();
      } catch (error) {}
    }
  }

  function pauseIntentional(el, video) {
    invalidatePlay(el);
    if (!video) return;
    try {
      video.pause();
    } catch (error) {}
  }

  function playRequestCurrent(el, serial, playAbort, binding) {
    return serial === el._lshkPlaySerial
      && el._lshkPlayAbort === playAbort
      && !!playAbort
      && !playAbort.signal.aborted
      && !!binding
      && binding === el._lshkMediaAbort
      && !binding.signal.aborted
      && el.isConnected
      && !el.classList.contains('is-failed');
  }

  function showFallback(el) {
    if (el.classList.contains('is-failed')) return;
    el.classList.add('is-failed');
    markPlaying(el, false);
    var video = el.querySelector('[data-lshk-video]');
    var images = el.querySelectorAll('[data-lshk-fallback-image]');
    var surface = el.querySelector('[data-lshk-fallback-surface]');
    var button = buttonFor(el);
    if (video) {
      pauseIntentional(el, video);
      video.removeAttribute('autoplay');
      video.setAttribute('hidden', '');
    }
    if (button) button.setAttribute('hidden', '');
    if (images.length) {
      for (var i = 0; i < images.length; i++) images[i].removeAttribute('hidden');
    } else if (surface) {
      surface.removeAttribute('hidden');
    }
  }

  function ensureMuted(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.removeAttribute('autoplay');
  }

  function requestPlay(el, video) {
    ensureMuted(video);
    invalidatePlay(el);
    var serial = el._lshkPlaySerial;
    var playAbort = new AbortController();
    var binding = el._lshkMediaAbort;
    el._lshkPlayAbort = playAbort;

    function settle(action) {
      if (!playRequestCurrent(el, serial, playAbort, binding)) return;
      action();
    }

    var pending;
    try {
      pending = video.play();
    } catch (error) {
      settle(function () { showFallback(el); });
      return;
    }
    if (pending && typeof pending.then === 'function') {
      try {
        pending.then(function () {
          settle(function () {
            if (reducedMotion() && el.getAttribute('data-lshk-user-play') !== 'true') {
              pauseIntentional(el, video);
              markPlaying(el, false);
              return;
            }
            markPlaying(el, true);
          });
        }).catch(function () {
          settle(function () { showFallback(el); });
        });
      } catch (error) {
        settle(function () { showFallback(el); });
      }
    } else {
      settle(function () { markPlaying(el, true); });
    }
  }

  function bind(el) {
    if (!el || el.getAttribute('data-' + BOUND) === 'true') return;
    var video = el.querySelector('[data-lshk-video]');
    if (!video) {
      el.setAttribute('data-' + BOUND, 'true');
      return;
    }
    el.setAttribute('data-' + BOUND, 'true');
    ensureMuted(video);
    markPlaying(el, false);

    var controller = new AbortController();
    var signal = controller.signal;
    el._lshkMediaAbort = controller;

    video.addEventListener('play', function () {
      if (!el.classList.contains('is-failed')) markPlaying(el, true);
    }, { signal: signal });

    video.addEventListener('pause', function () {
      if (!el.classList.contains('is-failed')) markPlaying(el, false);
    }, { signal: signal });

    video.addEventListener('error', function () {
      showFallback(el);
    }, { signal: signal });

    var button = buttonFor(el);
    if (button) {
      button.addEventListener('click', function () {
        if (el.classList.contains('is-failed')) return;
        if (el.getAttribute('data-lshk-playing') === 'true') {
          el.setAttribute('data-lshk-user-play', 'false');
          pauseIntentional(el, video);
          markPlaying(el, false);
          return;
        }
        el.setAttribute('data-lshk-user-play', 'true');
        requestPlay(el, video);
      }, { signal: signal });
    }

    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var onMotion = function () {
      if (!el.isConnected) {
        invalidatePlay(el);
        controller.abort();
        return;
      }
      if (motion.matches) {
        el.setAttribute('data-lshk-user-play', 'false');
        pauseIntentional(el, video);
        markPlaying(el, false);
      }
    };
    if (motion.addEventListener) {
      motion.addEventListener('change', onMotion, { signal: signal });
    } else if (motion.addListener) {
      motion.addListener(onMotion);
      el._lshkMediaMotion = { query: motion, handler: onMotion };
    }

    if (!reducedMotion()) requestPlay(el, video);
  }

  function init(root) {
    if (!root) return;
    if (root.matches && root.matches('[data-lshk-media]')) bind(root);
    if (!root.querySelectorAll) return;
    var nodes = root.querySelectorAll('[data-lshk-media]');
    for (var i = 0; i < nodes.length; i++) bind(nodes[i]);
  }

  function dispose(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = [];
    if (root.matches && root.matches('[data-lshk-media]')) nodes.push(root);
    var found = root.querySelectorAll('[data-lshk-media]');
    for (var i = 0; i < found.length; i++) nodes.push(found[i]);
    for (var n = 0; n < nodes.length; n++) {
      var el = nodes[n];
      if (el._lshkMediaAbort) el._lshkMediaAbort.abort();
      if (el._lshkMediaMotion) {
        el._lshkMediaMotion.query.removeListener(el._lshkMediaMotion.handler);
      }
      var video = el.querySelector('[data-lshk-video]');
      invalidatePlay(el);
      if (video) {
        try {
          video.pause();
        } catch (error) {}
        video.removeAttribute('src');
        try {
          video.load();
        } catch (error) {}
      }
      el.removeAttribute('data-' + BOUND);
      delete el._lshkMediaAbort;
      delete el._lshkMediaMotion;
      delete el._lshkPlayAbort;
      delete el._lshkPlaySerial;
    }
  }

  function rootFromEvent(event) {
    var target = event && event.target;
    if (target && target.querySelectorAll) return target;
    var id = event && event.detail && event.detail.sectionId;
    if (id && document.getElementById) {
      return document.getElementById('shopify-section-' + id) || document;
    }
    return document;
  }

  function onLoad(event) {
    init(rootFromEvent(event));
  }

  function onUnload(event) {
    var target = event && event.target;
    if (!target || target === document || target === document.documentElement || target === document.body) return;
    dispose(target);
  }

  if (!window.__lshkMediaEventsBound) {
    window.__lshkMediaEventsBound = true;
    document.addEventListener('shopify:section:load', onLoad);
    document.addEventListener('shopify:section:unload', onUnload);
  }

  window.lshkMedia = { init: init, dispose: dispose };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
